import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_membership_points_to_currency_rate_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;  
  point_currency: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  ratio_numeric: fromDatatype.NumericDatatypeInterface;

  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_crm_membership_points_to_currency_rate_hdr_RowClass
  implements bl_crm_membership_points_to_currency_rate_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  point_currency: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  ratio_numeric: fromDatatype.NumericDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
